const en = {
  hero: {
    workedFor: "worked for",
    role: "Software Engineer",
    bio: "just love building things that make life easier.",
    bio2: "most of my projects started as solutions to my own daily problems and evolved into practical applications for others.",
    bio3: "I believe everyone in this world has a purpose, but mine? use my knowledge for building to push humanity forward, delivering solutions that help society reach for the stars ✨.",
    graduated: "Graduated",
    degree: "Systems Engineering · UTN, Argentina",
    experience: "Experience",
    experienceLine: "7+ years shipping production software",
    alwaysLearning: "Always Learning",
    learningLine: "8+ certifications & courses",
    contactMe: "Contact me",
  },
  sections: {
    techStack: "Tech Stack",
    experience: "Experience",
    sideProjects: "Side Projects",
    sideProjectsSub: "Things I built outside of work — to scratch an itch, learn something, or solve my own problems.",
  },
  experience: {
    problem: "Problem",
    solution: "Solution",
    impact: "Impact",
    present: "Present",
  },
  footer: {
    tagline: "Software Engineer",
  },
};

export default en;
